import type { ReactNode } from "react";
import { Share2 } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export default function NextStepsCard({ steps }: { steps: ReactNode[] }) {
  return (
    <Card>
      <CardHeader className="border-b py-3">
        <CardTitle className="flex items-center gap-2 text-base font-semibold text-slate-900">
          <Share2 className="h-4 w-4 text-muted-foreground" />
          What happens next
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-6">
        <ol className="grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
          {steps.map((step, i) => (
            <li
              key={i}
              className="flex items-start gap-3 rounded-lg border border-slate-200 bg-slate-50/60 p-3"
            >
              <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-primary text-[11px] font-semibold text-primary-foreground">
                {i + 1}
              </span>
              <span className="text-sm text-slate-600">{step}</span>
            </li>
          ))}
        </ol>
      </CardContent>
    </Card>
  );
}
